import { colors, Surface, Txt } from '@vst/beam';
import { DownloadOutlined } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

type DownloadSpeedCharacteristicProps = {
  downloadSpeed: string;
  downloadUnits: string;
};

const DownloadSpeedCharacteristic = ({ downloadSpeed, downloadUnits }: DownloadSpeedCharacteristicProps) => {
  const { t } = useTranslation('ChangePlan');
  return (
    <Surface className={styles['download-speed-container']} data-cy="download-speeds-attribute">
      <DownloadOutlined style={{ color: colors['gray'][600] }} width={20} height={20} />
      <Surface className={styles['text-container']}>
        <Txt variant="smallBold" component="span">
          {downloadSpeed} {downloadUnits}
        </Txt>
        <Txt variant="smallRegular" component="span">
          {t('orderReview.cartDetails.downloadSpeeds')}
        </Txt>
      </Surface>
    </Surface>
  );
};

export default DownloadSpeedCharacteristic;
